
import React, { useState } from "react";
import Topratingsfood from "../../Promotionsanddiscounts/Food/Topratingsfood";
import Foodvendorcoupsdetails from "../../Promotionsanddiscounts/Food/Foodvendorcoupsdetails"
import Cancelandrefundpage from "./Cancelandrefundpage";
import Foodsettlementpage from "./Foodsettlementpage";
import VendorCreditspoints from "../../Promotionsanddiscounts/Food/VendorCreditspoints.jsx"
const TabsLayout = () => {
  const [activeTab, setActiveTab] = useState("Cancel/Refund");

  const DummySection = ({ title }) => (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );

  const renderComponent = () => {
    switch (activeTab) {
      case "Cancel/Refund":
        return <Cancelandrefundpage />;
      case "Vendor Settlement":
        return <Foodsettlementpage />;

      // case "Vendor Rating":
      //   return <Topratingsfood title="History" />;
      case "Vendor Credits":
        return <VendorCreditspoints title="Quotation" />;
      default:
        return <Cancelandrefundpage />;
    }
  };

  const tabs = [
    "Cancel/Refund",
    "Vendor Settlement",
    // "Vendor List",
    // "Vendor Rating",
    "Vendor Credits"

  ];

  return (
    <div className="tabs-wrapper">
      {/* TOP ONE-ROW TABS (ALL SCREENS) */}
      <div className="tabs-row">
        {tabs.map((tab) => (
          <span
            key={tab}
            className={`row-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </span>
        ))}
      </div>

      {/* CONTENT */}
      <div className="tabs-content">
        {renderComponent()}
      </div>
    </div>
  );
};

export default TabsLayout;

